import { Send, ShieldCheck, PhoneCall } from "lucide-react";
import { Chapter, Reveal } from "@/components/Reveal";

const STEPS = [
  {
    num: "01",
    icon: Send,
    title: "Send Us a Message",
    desc: "Share your requirements through our contact form or WhatsApp — a role to fill, a company to register, a compliance deadline.",
  },
  {
    num: "02",
    icon: ShieldCheck,
    title: "We Verify Your Details",
    desc: "Our team reviews your information for accuracy and suitability, then maps it to the right specialists on our bench.",
  },
  {
    num: "03",
    icon: PhoneCall,
    title: "We Reach Out to You",
    desc: "Expect a prompt call from us to discuss your needs, align on timelines, and guide you forward — usually the same day.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="process"
      className="py-24 md:py-32"
      data-testid="how-it-works-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <Chapter num="Chapter 01" label="The Process" />
          <h2 className="font-heading text-4xl sm:text-5xl tracking-tight leading-tight font-medium text-white max-w-2xl">
            Let's get connected. Three steps, zero friction.
          </h2>
        </Reveal>

        <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {STEPS.map((step, i) => (
            <Reveal key={step.num} delay={i * 0.15} className="bg-zinc-950">
              <div
                className="relative p-10 md:p-12 h-full group hover:bg-zinc-900/60 transition-colors duration-500"
                data-testid={`process-step-${i}`}
              >
                <span className="absolute top-6 right-8 font-heading text-7xl md:text-8xl font-bold text-white/5 group-hover:text-primary/10 transition-colors duration-500 select-none">
                  {step.num}
                </span>
                <step.icon className="w-8 h-8 text-primary mb-8" strokeWidth={1.5} />
                <h3 className="font-heading text-2xl font-medium text-white mb-4">
                  {step.title}
                </h3>
                <p className="text-zinc-400 leading-relaxed text-sm md:text-base">
                  {step.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
